import { PackagesPolicy } from '@playq/octopus2-economy';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';

import { appsPackagesService } from './constants';

export const appsPackagePolicyKeys = ['apps', 'package', 'policy'];

export const useAppsPackagePolicy = (
  options?: IUseQueryOptionsExtended<PackagesPolicy | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(appsPackagePolicyKeys, () => appsPackagesService.policy(), options);
  const data = res.data instanceof PackagesPolicy ? res.data : new PackagesPolicy();

  return { ...res, data, keys: appsPackagePolicyKeys };
};
